/**
 * ConfirmDialog — 삭제·완료 처리 등 되돌리기 어려운 동작 전 확인 팝업(공용).
 * ui-core Modal 을 title 없이 써서 제목 영역(제목·X)을 두지 않고 본문 + 버튼 영역만 그린다.
 * 버튼: [취소](secondary) · [확인 동작](primary). Esc·바깥 클릭은 취소와 같다(진행 중엔 막음).
 */
import type { ReactNode } from 'react';
import { Button, Modal } from '@indipia/ui-core';

export function ConfirmDialog({
  open, message, description, confirmLabel = '삭제', pendingLabel, isPending = false, onConfirm, onCancel,
}: {
  open: boolean;
  message: ReactNode;
  description?: ReactNode;
  confirmLabel?: string;
  /** 진행 중 버튼 문구 — 생략 시 confirmLabel 유지 */
  pendingLabel?: string;
  isPending?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <Modal
      open={open}
      size="sm"
      onClose={() => { if (!isPending) onCancel(); }}
      footerAlign="stretch"
      footer={
        <>
          <Button type="button" variant="secondary" onClick={onCancel} disabled={isPending}>취소</Button>
          <Button type="button" variant="primary" onClick={onConfirm} disabled={isPending} loading={isPending}>
            {isPending && pendingLabel ? pendingLabel : confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-body-md font-bold text-text">{message}</p>
      {description && <p className="mt-1.5 text-body-sm text-text-muted">{description}</p>}
    </Modal>
  );
}
